<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import responsive from '@/js/utils/responsive.js';
  import { resetHero } from '@/js/utils/stores.js';
  import { menuOpenState } from '@/js/utils/stores.js';

  export let video;
  export let loading;

  //handle no-scroll on menu open
  let open;
  menuOpenState.subscribe((value) => {
    open = value;
  });

  // Curtain animation
  export let hideContent = false;

  const dispatch = createEventDispatcher();

  let heroVideoEl, windowWidth, windowSrollY;

  let curtianOffset = 0;
  let curtainLeft = 0;
  let curtainRight = 0;

  $: curtianOffset;

  function lazyLoadVideo() {
    const req = new XMLHttpRequest();
    req.open('GET', video, true);
    req.responseType = 'blob';

    req.onload = function () {
      if (this.status == 200) {
        var myBlob = this.response;
        var vid = (window.webkitURL || window.URL).createObjectURL(myBlob);
        // myBlob is now the blob that the object URL pointed to.
        heroVideoEl.src = vid;
        // Dispatch loaded
        dispatch('loaded');
      }
    };

    req.send();
  }

  onMount(() => {
    if (!loading && responsive.m < windowWidth && windowSrollY < 100) {
      drawCurtain(0);
      document.documentElement.classList.add('no-scroll');
    }

    // Lazy load video.
    lazyLoadVideo();
  });

  // Reset hero cutain.
  resetHero.subscribe((value) => {
    if (true == value) {
      curtianOffset = 0;
      resetHero.set(false);

      drawCurtain(curtianOffset);
    }
  });

  /**
   * Handle wheel event.
   * @param e
   */
  function handleWheel(e) {
    if (loading) {
      return;
    }

    if (windowWidth <= responsive.m) {
      return;
    }

    if (windowSrollY > 100) {
      return;
    }

    drawCurtain(e.deltaY);
  }

  /**
   * Draw curtain.
   */
  function drawCurtain(offset) {
    // Maximum curtain offset in percentage.
    const maxPercent = 26;
    // Maximum scroll offset.
    const maxOffset = 306;

    curtianOffset += offset;

    if (0 >= curtianOffset) {
      curtianOffset = 0;
    }
    if (maxOffset <= curtianOffset) {
      curtianOffset = maxOffset;
    }

    // Header.
    if (maxOffset / 2 < curtianOffset) {
      document.documentElement.classList.add('hero-full');
    } else {
      document.documentElement.classList.remove('hero-full');
    }

    let curtainOffset = (curtianOffset * maxPercent) / maxOffset;

    curtainLeft = -Math.round(curtainOffset);
    curtainRight = Math.round(curtainOffset);

    // hideContent = curtianOffset >= maxOffset * 0.75;

    // Allow scroll past range
    if ((curtianOffset >= maxOffset) & !open) {
      document.documentElement.classList.remove('no-scroll');
    } else {
      document.documentElement.classList.add('no-scroll');
    }
  }
</script>

<svelte:window
  on:wheel={handleWheel}
  bind:innerWidth={windowWidth}
  bind:scrollY={windowSrollY}
/>

<div class="hero-video">
  <div
    class="hero-video__curtain hero-video__curtain--left"
    style="transform: translateX({curtainLeft}%)"
  />
  <div
    class="hero-video__curtain hero-video__curtain--right"
    style="transform: translateX({curtainRight}%)"
  />
  <video
    class="hero-video__video"
    bind:this={heroVideoEl}
    muted
    loop
    autoplay
    playsinline
  />
  <div class="hero-video__noise" />
</div>

<style lang="scss">
  .hero-video {
    position: absolute;
    inset: 0;
    z-index: -1;

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &__noise {
      position: absolute;
      z-index: 0;
      inset: 0;
      background: url(img/noise.png) 300px 300px;
    }

    &__curtain {
      position: absolute;
      z-index: 1;
      top: 0;
      bottom: 0;
      width: 50vw;

      background: url(img/groovepaper.png) 300px 300px, rgb(var(--white));

      transition: transform 0.25s;
      will-change: transform;

      &--left {
        @include resp-max('s') {
          transform: translateX(-15%) !important;
        }

        left: 0;
        margin-left: -8%;

        clip-path: polygon(0 0, 100% 0%, 75% 100%, 0% 100%);
      }

      &--right {
        @include resp-max('s') {
          transform: translateX(15%) !important;
        }

        right: 0;
        margin-right: -8%;

        clip-path: polygon(25% 0, 100% 0%, 100% 100%, 0% 100%);
      }
    }
  }
</style>
